import { Component } from '@angular/core';

import { DrawerModule } from 'primeng/drawer';

import { drawerHeaderDesignToken } from 'src/app/primeng-design-tokens/drawer-header';
import { environment } from '../../../environments/environment';

/**
 * Footer entry that opens the analytics transparency notice.
 *
 * The wording comes from the Fenix Web Analytics SDK (`window.AnalyticsSDK.NOTICE`) so every
 * Test Tools application shows identical copy. The notice is informational only — no consent is
 * collected, and collection is not gated on any acknowledgement. Renders nothing meaningful until
 * the SDK script has loaded.
 */
@Component({
	selector: 'app-privacy-notice',
	imports: [DrawerModule],
	templateUrl: './privacy-notice.component.html',
	styleUrl: './privacy-notice.component.scss',
})
export class PrivacyNoticeComponent {
	/** Controls the drawer visibility. */
	public visible = false;

	/** Traton-blue drawer theming, matching the header and the other Test Tools apps. */
	public drawerHeaderDesignToken = drawerHeaderDesignToken;

	/**
	 * Whether to surface the notice at all. Only shown when web analytics is actually configured
	 * for this build (`analyticsSdkScriptUrl` set). China builds omit that config and collect no
	 * analytics data, so the notice must not appear there — a "we collect data" notice where nothing
	 * is collected would be misleading. This mirrors the guard in BrowserAnalyticsService.
	 */
	public get showNotice(): boolean {
		return !!environment.analyticsSdkScriptUrl?.trim();
	}

	/**
	 * Shared analytics transparency-notice text sourced from the SDK. Undefined until the SDK
	 * script has loaded.
	 */
	public get notice(): NonNullable<Window['AnalyticsSDK']>['NOTICE'] | undefined {
		return window.AnalyticsSDK?.NOTICE;
	}

	/** Opens the privacy notice drawer. */
	public open(): void {
		this.visible = true;
	}
}
